module.exports = __webpack_public_path__ + "static/media/loginbg.3a979d8b.jpg";